<template>
  <article
    class="rounded-2xl"
    :class="{ 'border-b-2 border-r-2 border-solid border-app-green': showBorder, 'bg-app-green-100 md:bg-white': mobileBgWhite, 'bg-white': !mobileBgWhite }"
  >
    <h3 v-if="title" class="mb-2 max-w-full break-words text-base font-bold leading-none uppercase">{{ title }}</h3>
    <slot />
  </article>
</template>

<script setup lang="ts">
import { toRefs } from 'vue'

interface Props {
  title?: string
  mobileBgWhite?: boolean
  showBorder?: boolean
}

const props = defineProps<Props>()
const { title, mobileBgWhite = false, showBorder = true } = toRefs(props)
</script>
